<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? $t('bloodBank.add-blood-compatibility')
          : $t('bloodBank.edit-boold-compatibility')
      "
    >
      <b-card-text>
        <b-row>
          <b-col md="12">
            <AutoComplete
              v-model="EditForm.blood_bottle_id"
              :label="$t('bloodBank.bottle-identifier')"
              :placeholder="$t('bloodBank.bottle-identifier')"
              param-query="bottle_identifier"
              :serializer="(val) => val.id"
              endpoint="bloodBottles"
              text-title="bottle_identifier"
              :otherQuery="`include=&filter[status]=available&filter[abo]=${this.$route.params.patient_abo}&filter[rh]=${this.$route.params.patient_rh === 'Negative' ? 'Negative' : 'Positive,Negative'}`"
              keyword="bottle_identifier"
            />
            <p class="text-danger mt-1">{{ errorForm.blood_bottle_id }}</p>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group
              :label="$t('bloodBank.room-temperature')"
              label-for="room_temperature"
            >
              <v-select
                v-model="EditForm.room_temperature"
                :options="[
                  { label: 'Null', value: 0 },
                  { label: 'Abnormal', value: 1 },
                ]"
                placeholder="Null, Abnormal"
                :serializer="(val) => val.label"
              />
              <p class="text-danger mt-1">{{ errorForm.room_temperature }}</p>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              :label="$t('bloodBank.incubator-temperature')"
              label-for="incubator_temperature"
            >
              <v-select
                v-model="EditForm.incubator_temperature"
                :options="[
                  { label: 'Null', value: 0 },
                  { label: 'Abnormal', value: 1 },
                ]"
                placeholder="Null, Abnormal"
                :serializer="(val) => val.label"
              />
              <p class="text-danger mt-1">
                {{ errorForm.incubator_temperature }}
              </p>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              :label="$t('bloodBank.anti-human-globulin')"
              label-for="anti_human_globulin"
            >
              <v-select
                v-model="EditForm.anti_human_globulin"
                :options="[
                  { label: 'Null', value: 'compatible' },
                  { label: 'Abnormal', value: 'incompatible' },
                ]"
                placeholder="Null, Abnormal"
                :serializer="(val) => val.label"
              />
              <p class="text-danger mt-1">
                {{ errorForm.anti_human_globulin }}
              </p>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              :label="$t('bloodBank.final-result')"
              label-for="final_result"
            >
              <v-select
                v-model="EditForm.final_result"
                :options="['compatible', 'incompatible']"
                placeholder="compatible, incompatible"
              />
              <p class="text-danger mt-1">{{ errorForm.final_result }}</p>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- <b-row>
                    <b-col md="12">
                        <b-form-group :label="$t('bloodBank.inserted-at')" label-for="inserted_at">
                            <datepicker v-model="EditForm.inserted_at" :calendar-button="true" :clear-button="true"
                                :bootstrap-styling="true" class="datebtn2" placeholder="YYYY-MM-DD"></datepicker>
                        </b-form-group>
                        <p class="text-danger mt-1">{{ errorForm.inserted_at }}</p>
                    </b-col>
                </b-row> -->
        <b-row> </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitItem"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{
            createMode ? $t("common.add") : $t("common.edit")
          }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>

    <b-card :title="isSho ? $t('office.sho') + ' ' + $t('bloodBank.sample-matching') : $t('bloodBank.sample-matching')">
      <div>
        <!-- Search Button -->
        <b-row>
          <br />
          <b-col cols="12" md="12">
            <b-button variant="primary" v-print="BLOOD" class="float-right" v-if="!isSho">
              {{ $t("common.print") }}
            </b-button>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2 v-if="!isSho">{{$t("bloodBank.blood-compatibility-table") }}</h2>
          <h2 v-else>{{ $t("office.sho") + ' ' + $t("bloodBank.blood-compatibility-table") }}</h2>
          <b-button variant="primary" @click="show(EditForm, 'create')" v-if="!isSho">
            {{ $t("bloodBank.add-blood-compatibility") }}
          </b-button>
        </div>

        <b-table
          :items="data"
          responsive
          :fields="bloodBottleTableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(anti_human_globulin)="data">
            <p style="font-size: 1.2rem">
              {{
                data.item.anti_human_globulin === "compatible"
                  ? "Null"
                  : "Abnormal"
              }}
            </p>
          </template>
          <template #cell(incubator_temperature)="data">
            <p style="font-size: 1.2rem">
              {{ data.item.incubator_temperature === 0 ? "Null" : "Abnormal" }}
            </p>
          </template>
          <template #cell(room_temperature)="data">
            <p style="font-size: 1.2rem">
              {{ data.item.room_temperature === 0 ? "Null" : "Abnormal" }}
            </p>
          </template>

          <template #cell(final_result)="data">
            <b-badge
              style="font-size: 1.2rem"
              :variant="
                data.item.final_result === 'compatible' ? 'success' : 'danger'
              "
              >{{ data.item.final_result }}</b-badge
            >
          </template>

          <template #cell(blood_transfusion.blood_transfusion_type_id)="data">
            <p style="font-size: 1.2rem">
              {{
                getTransfusionType(
                  data.item.blood_transfusion.blood_transfusion_type_id
                )
              }}
            </p>
          </template>

          <template #cell(blood_bottle.status)="data">
            <!-- <b-badge :variant="data.item.blood_bottle.status === 'available' ? 'success' : 'danger'">{{
                            data.item.blood_bottle.status }}</b-badge> -->

            <b-button
              v-if="getNestedProperty(data.item, 'blood_bottle.status') === 'available'"
              variant="outline-success"
              :disabled="data.item.final_result === 'incompatible'"
              @click="dispense(data.item)"
              size="sm"
            >
              {{ $t("bloodBank.dispense") }}
            </b-button>
            <b-button
              v-else
              variant="outline-danger"
              @click="retrieve(data.item)"
              size="sm"
            >
              {{ $t("bloodBank.retrieve") }}
            </b-button>
          </template>
          <template #cell(blood_bottle.bottle_identifier)="data">
            <p style="font-size: 1.2rem">
              {{ getNestedProperty(data.item, 'blood_bottle.bottle_identifier') }}
            </p>
          </template>
          <template #cell(blood_transfusion.patient_abo)="data">
            <p style="font-size: 1.2rem">
              {{ data.item.blood_transfusion.patient_abo }}
            </p>
          </template>
          <template #cell(blood_transfusion.patient_rh)="data">
            <p style="font-size: 1.2rem">
              {{ data.item.blood_transfusion.patient_rh }}
            </p>
          </template>
          <template #cell(print)="data">
            <div class="d-flex justify-content-between">
              <b-button
                v-if="isSho && data.item.final_result === 'compatible'"
                size="sm"
                pill
                variant="secondary"
                class="mr-2"
                @click="
                $router.push({
                  name: 'blood-compatibility-update',
                  params: {
                    blood_compatibility_id: data.item.id,
                    pateint_card_id: data.item.blood_transfusion.patient_card_id,
                  },
                })
              "
            >
              {{ $t("office.update-info") }}
            </b-button>

            <b-button
              variant="primary"
              @click="transfusionNoteReport(data.item)"
              pill
            >
              {{ $t("common.print") }}
              </b-button>
            </div>
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data" >
            <div class="text-nowrap" >
              <ActionsButtons
                deletePerm="get-bloodCompatibility"
                editPerm="get-bloodCompatibility"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
                :disabled="isSho"

              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getBloodCompatibilities()"
            >
              <b-pagination
                v-model="page"
                :total-rows="dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>

    <TransfusionNote ref="print" :data="printData" />
    <BLOOD :data="data" />
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BFormCheckbox,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BBadge,
  BCardText,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import Datepicker from "vuejs-datepicker";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
const TransfusionNote = () =>
  import("@/components/printables/TransfusionNote.vue");
  const BLOOD = () => import("@/components/printables/bloodCompatibilities.vue");

import permissionChecker from "@/mixins/permissionChecker";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import axios from "axios";
export default {
  mixins: [permissionChecker],

  components: {
    DeleteModal,
    BFormCheckbox,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    Datepicker,
    BFormTextarea,
    StatisticCardHorizontal,
    BBadge,
    AutoComplete,
    TransfusionNote,
    BLOOD,
    BFormSelect,
    BFormDatepicker,
    BCardText,
    vSelect,
  },
  data() {
    return {
      take: 1000,
      loading: true,
      dataCount: 0,
      data: [],
      printData: {},
      EditForm: {
        blood_transfusion_id: "",
        blood_bottle_id: "",
        room_temperature: "",
        incubator_temperature: "",
        anti_human_globulin: "",
        final_result: "",
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        blood_transfusion_id: "",
        blood_bottle_id: "",
        room_temperature: "",
        incubator_temperature: "",
        anti_human_globulin: "",
        final_result: "",
      },
      params: {
        form: {},
        path: "",
      },
      bloodBottleTableColumns: [
        {
          key: "blood_bottle.bottle_identifier",
          sortable: true,
          label: this.$t("bloodBank.bottle-identifier"),
        },
        {
          key: "blood_transfusion.blood_transfusion_type_id",
          sortable: true,
          label: this.$t("bloodBank.blood-transfusion-type"),
        },
        // {
        //     key: "blood_bottle.abo",
        //     sortable: true,
        //     label: this.$t("bloodBank.abo"),
        // },
        // {
        //     key: "blood_bottle.rh",
        //     sortable: true,
        //     label: this.$t("bloodBank.rh"),
        // },

        {
          key: "blood_bottle.status",
          sortable: true,
          label: this.$t("bloodBank.status"),
        },
        {
          key: "blood_transfusion.patient_abo",
          sortable: true,
          label: this.$t("bloodBank.patient-abo"),
        },
        {
          key: "blood_transfusion.patient_rh",
          sortable: true,
          label: this.$t("bloodBank.patient-rh"),
        },

        {
          key: "room_temperature",
          sortable: true,
          label: this.$t("bloodBank.room-temperature"),
        },
        {
          key: "incubator_temperature",
          sortable: true,
          label: this.$t("bloodBank.incubator-temperature"),
        },
        {
          key: "anti_human_globulin",
          sortable: true,
          label: this.$t("bloodBank.anti-human-globulin"),
        },
        {
          key: "final_result",
          sortable: true,
          label: this.$t("bloodBank.final-result"),
        },
        {
          key: "print",
          sortable: true,
          label: this.$t("common.print"),
        },

        {
          key: "Actions",
          label: this.$t("common.actions"),
          thStyle: { width: "150px" },
        },
      ],

      aboOptions: ["A", "B", "AB", "O"],
      rhOptions: ["Positive", "Negative"],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      page: 1,
      BLOOD: {
        id: "BLOOD",
      },

      abo: "",
      rh: "",
      production_date: "",
      expiration_date: "",
      bottle_identifier: "",
      inserted_at: "",

      statusOptions: ["available", "dispensed"],
      searchDate: "",
      selectedSearch: "",
      from_date: "",
      to_date: "",
      status: "",
      transfusionTypes: [],
      patientCard: {},
      isSho: null,
    };
  },
  mounted() {
    this.getTransfusionTypeList();
    this.getBloodCompatibilities();
    console.log("this.$route.params", this.$route.params);
    this.isSho = this.$route.params.isSho === 'true' || this.$route.params.isSho === true ;
    console.log("this.isSho", this.isSho);
  },
  watch: {
    searchDate(newVal) {
      this.selectedSearch = newVal || "";
    },
  },
  methods: {
    getNestedProperty(obj, path, defaultValue = "N/A") {
      const result = path
        .split(".")
        .reduce(
          (acc, part) => (acc && acc[part] ? acc[part] : defaultValue),
          obj
        );
      // if (typeof result === "string" && result.startsWith("\\")) {
      //   return defaultValue;
      // }
      console.log("result", result);
      return result;
    },
    async transfusionNoteReport(item) {
      this.printData = {};
      await this.getPatientCard(item.blood_transfusion.patient_card_id);
      this.printData = item;

      if (item.blood_transfusion_reaction.length > 1) {
        this.printData.blood_transfusion_reaction = [
          item.blood_transfusion_reaction[
            item.blood_transfusion_reaction.length - 1
          ],
        ];
      }

      if (
        Array.isArray(this.printData.vital_signs) &&
        this.printData.vital_signs.length > 0
      ) {
        this.printData.vital_signs = this.arrangeVitalSigns(
          this.printData.vital_signs
        );
      }

      this.printData.patient_card = this.patientCard;
      console.log("this.printData", this.printData);
      this.$nextTick(() => {
        this.$refs.print.generateReport();
      });
    },
    arrangeVitalSigns(vitalSigns) {
      const transformedData = {};
      if (vitalSigns.length === 0) return transformedData;
      vitalSigns.forEach((sign) => {
        const minutesAfterTransfusion = Math.abs(
          sign.minutes_after_transfusion
        );

        if (!transformedData[sign.vital_sign_type]) {
          transformedData[sign.vital_sign_type] = {
            name: sign.vital_sign_type,
          };
        }
        transformedData[sign.vital_sign_type][
          `minutes_after_transfusion_${minutesAfterTransfusion}`
        ] = sign.numeric_value;
      });

      // Filter out entries that do not have all required minutes_after_transfusion values
      // const requiredMinutes = [-1, 15, 30, 60, 120, 180, 240];
      // const result = Object.values(transformedData).filter((entry) => {
      //   return requiredMinutes.every(
      //     (minute) => `minutes_after_transfusion-(${minute})` in entry
      //   );
      // });

      // console.log("transformedData", transformedData);
      return transformedData;
    },
    async getPatientCard(patientId) {
      await this.getList(`/patientCard/${patientId}`);
      this.patientCard = this.all_data;
      // console.log("this.patientCard", this.patientCard);
    },
    async getTransfusionTypeList() {
      await this.getList(`/bloodTransfusionTypes`);
      this.transfusionTypes = this.all_data.data;
      // console.log("this.transfusionTypes", this.transfusionTypes);
    },
    formatDate(ivfDate) {
      const date = new Date(ivfDate);
      const year = date.getFullYear();
      let month = "" + (date.getMonth() + 1);
      let day = "" + date.getDate();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return `${year}-${month}-${day}`;
    },
    show(item, mode) {
      console.log("item", item);
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          _method: "POST",
        };
      } else {
        this.createMode = false;
        this.EditForm.id = item.id;
        this.EditForm.blood_transfusion_id = item.blood_transfusion_id;
        this.EditForm.blood_bottle_id = item.blood_bottle_id;
        this.EditForm.room_temperature = item.room_temperature;
        this.EditForm.incubator_temperature = item.incubator_temperature;
        this.EditForm.anti_human_globulin = item.anti_human_globulin;
        this.EditForm.final_result = item.final_result;

        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },
    async getBloodCompatibilities() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/bloodCompatibilities?page=${this.page}&take=${
        this.searchDate && (this.from_date || this.to_date) ? 1000 : 15
      }&sort=-id&filter[blood_transfusion_id]=${
        this.$route.params.blood_transfusion_id
      }&include[]=bloodBottle&include[]=bloodTransfusion&include[]=bloodTransfusionReaction&include[]=vitalSigns`;

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/bloodCompatibilities/${this.deleteForm.id}`)
        .then((response) => {
          this.getBloodCompatibilities();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text:
                "deleted " +
                this.deleteForm.bottle_identifier +
                " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.bottle_identifier,
            },
          });
        });
    },

    submitItem() {
      let count = 0;
      this.loading = true;
      this.errorForm.blood_transfusion_id = "";
      this.errorForm.blood_bottle_id = "";
      this.errorForm.room_temperature = "";
      this.errorForm.incubator_temperature = "";
      this.errorForm.anti_human_globulin = "";
      this.errorForm.final_result = "";
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }
      this.EditForm.blood_transfusion_id =
        this.$route.params.blood_transfusion_id || null;

      if (!this.EditForm.blood_transfusion_id) {
        count++;
        this.errorForm.blood_transfusion_id =
          "The blood transfusion id field is required.";
      }
      if (!this.EditForm.blood_bottle_id) {
        count++;
        this.errorForm.blood_bottle_id =
          "The blood bottle id field is required.";
      }
      if (!this.EditForm.room_temperature) {
        count++;
        this.errorForm.room_temperature =
          "The room temperature field is required.";
      }
      if (!this.EditForm.incubator_temperature) {
        count++;
        this.errorForm.incubator_temperature =
          "The incubator temperature field is required.";
      }
      if (!this.EditForm.anti_human_globulin) {
        count++;
        this.errorForm.anti_human_globulin =
          "The anti human globulin field is required.";
      }
      if (!this.EditForm.final_result) {
        count++;
        this.errorForm.final_result = "The final result field is required.";
      }
      this.EditForm.anti_human_globulin =
        this.EditForm.anti_human_globulin.value;
      this.EditForm.room_temperature = this.EditForm.room_temperature.value;
      this.EditForm.incubator_temperature =
        this.EditForm.incubator_temperature.value;
      console.log("editForm", this.EditForm);
      if (count > 0) {
        this.loading = false;
        return false;
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/bloodCompatibilities`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.$bvModal.hide("modal-edit");
              this.loading = false;
              console.log("this.expenses", this.expenses);
              this.getBloodCompatibilities();
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/bloodCompatibilities/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.$bvModal.hide("modal-edit");
              this.loading = false;
              this.getBloodCompatibilities();
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
    getTransfusionType(id) {
      const transfusionType = this.transfusionTypes;
      // console.log("transfusionType1111", transfusionType);

      if (id) {
        // console.log("id", id);
        const writeType = transfusionType.find((type) => type.id === id);
        // console.log("writeType", writeType);
        return writeType.name;
      }

      //   return transfusionType;
    },
    dispense(item) {
      console.log("item", item);
      axios
        .put(`/bloodCompatibilities/dispenseBottle/${item.id}`)
        .then((response) => {
          this.getBloodCompatibilities();
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Success",
              variant: "success",
              text: "Dispensed successfully",
            },
          });
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = false;
          if (error.response.status) {
            for (let item in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Error",
                  variant: "danger",
                  text: error.response.data[item][0],
                },
              });
            }
          }
        });
    },
    retrieve(item) {
      axios
        .put(`/bloodCompatibilities/revertBottle/${item.id}`)
        .then((response) => {
          this.getBloodCompatibilities();
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Success",
              variant: "success",
              text: "Retrieved successfully",
            },
          });
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = false;
          if (error.response.status) {
            for (let item in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Error",
                  variant: "danger",
                  text: item.message,
                },
              });
            }
          }
        });
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
